import { Page } from '@/components';
import { BuildingInspectionGrid } from '@/pages/Tools/BuildingInspection/components/BuildingInspectionGrid';

const BuildingInspection = () => {
  return (
    <Page>
      <BuildingInspectionGrid />
    </Page>
  );
};

export default BuildingInspection;
